import { Tag } from '~/interfaces/Tag';
import RemoveTagFilterIcon from '../icons/RemoveTagFilterIcon';
import { ScrollArea, ScrollBar } from '../ui/scroll-area';

export default function ScrollableTagList({
  onRemoveTag,
  tagFilters,
  tags,
}: {
  onRemoveTag: (tagId: string) => void;
  tagFilters: string[];
  tags: Tag[];
}) {
  return (
    <ScrollArea className="whitespace-nowrap px-2" scrollHideDelay={1} style={{ scrollbarWidth: 'none' }}>
      <ul className="flex items-center justify-start gap-x-1 pt-3">
        {tagFilters.map((tagId) => {
          const tagData = tags.find((tag) => tag.parentTemplateTagId === Number(tagId));
          if (!tagData) return null;
          return (
            <li key={tagId} className="flex items-center justify-center gap-x-1">
              <span className="min-w-fit rounded-3xl border border-brown-dark bg-taupe-light-20 px-2 py-[2px] text-[11px] font-bold uppercase text-brown-dark">
                {tagData.tagTitle}
              </span>
              <button
                type="button"
                className="flex items-center justify-center"
                onClick={() => onRemoveTag(tagId.toString())}
              >
                <RemoveTagFilterIcon />
              </button>
            </li>
          );
        })}
      </ul>
      <ScrollBar orientation="horizontal" className="h-0 w-0" />
    </ScrollArea>
  );
}
